import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { AppConfig } from "@models/appConfig";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const appConfigApi = createApi({
  reducerPath: "appConfigApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/app-config`,
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    getAppConfig: builder.query<AppConfig, void>({
      query: () => "",
    }),
  }),
});

export const { useGetAppConfigQuery } = appConfigApi;
